import { IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { OpConfigurationProfileFunction } from './op-configuration-profile-function'

export class OpScheduleConfiguration extends OpConfigurationProfileFunction implements IJsonSerializable {

    //#region Properties
    
    public isEnable: boolean
    public isLocalTime: boolean
    public command: Enums.CommandCode
    public dayOfMonth: number
    public dayOfWeek: Enums.WeekDay[]
    public hourOfDay: number
    public minutesOfHour: number

    //#endregion


    //#region CustomProperties

    public scheduleDisplayText: string

    //#endregion


    //#region Ctor
    
    constructor(opObj: any) {
        super(opObj)
        super.fromJSON(opObj)
    }

    //#endregion


    //#region IJsonSerializable Implementation

    public toJSON(compressed: boolean = false): any {
        return {
            IsEnable: this.isEnable,
            IsLocalTime: this.isLocalTime,
            Command: this.command,
            DayOfMonth: this.dayOfMonth,
            DayOfWeek: this.dayOfWeek,
            HourOfDay: this.hourOfDay,
            MinutesOfHour: this.minutesOfHour,
            ScheduleDisplayText: this.scheduleDisplayText
        }
    }

    public fromJSON(opObj: any, compressed: boolean = false): void {
        this.isEnable = opObj.IsEnable
        this.isLocalTime = opObj.IsLocalTime
        this.command = opObj.Command
        this.dayOfMonth = opObj.DayOfMonth
        this.dayOfWeek = opObj.DayOfWeek
        this.hourOfDay = opObj.HourOfDay
        this.minutesOfHour = opObj.MinutesOfHour
        this.scheduleDisplayText = opObj.ScheduleDisplayText
    }

    //#endregion
}